import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { programService } from 'src/config/rootService';

import { Markdown } from 'src/modules/newPrograms/components/Markdown';
import { Page, PageProps } from 'src/modules/newPrograms/components/Page';
import { ProgramPageFragment } from 'src/modules/newPrograms/documents/getProgram.generated';
import { DeprecatedTextArea } from 'src/shared/components/Input';

import { useProgramContext } from '../contexts/programContext';

interface TextInputPageProps extends PageProps {
    page: ProgramPageFragment;
}

export enum TextInputPageTestID {
    Input = 'TextInputPageTestID.Input',
}

export const TextInputPage: FC<TextInputPageProps> = ({
    page,
    onNavigatePrev,
    onNavigateNext,
    navigationComponent,
}) => {
    const { t } = useTranslation();
    const { finish, isLastPage } = useProgramContext();

    const pageAnswers = page.parsedAnswerOptions;

    const handleBlur = () => {
        if (isLastPage) {
            finish();
        }
    };

    return (
        <Page
            onNavigatePrev={onNavigatePrev}
            onNavigateNext={onNavigateNext}
            navigationComponent={navigationComponent}
        >
            <Markdown
                textHorizontalAlignment={page.contentHorizontalAlignment}
                text={page.content ?? ''}
            />
            <DeprecatedTextArea
                value={pageAnswers?.[0]?.customOptionValue ?? ''}
                onBlur={handleBlur}
                onChange={data => {
                    programService.selectPageAnswer(page.id, 0, true, String(data));
                }}
                placeholder={t('programs:components.program_page.placeholder.text_input')}
                fieldId="answer"
                testID={TextInputPageTestID.Input}
            />
        </Page>
    );
};
